<dx-select-box
    [label]="label"
    [value]="value"
    (onValueChanged)="onValueChanged($event)"
    [dataSource]="items"
    valueExpr="value"
    displayExpr="name"
    fieldTemplate="field"
    itemTemplate="item"
    [readOnly]="readOnly"
    stylingMode="filled"
    width="100%"
>
    <dx-validator [validationRules]="validators"></dx-validator>

    <div *dxTemplate="let data of 'field'">
        <app-color-swatch [color]="data?.color">
             <dx-text-box [readOnly]="true" [value]="data?.name" class="flex-grow-1 border-0"></dx-text-box>
        </app-color-swatch>
    </div>

    <div *dxTemplate="let data of 'item'">
         <app-color-swatch [color]="data.color" [text]="data.name"></app-color-swatch>
    </div>
</dx-select-box>
